<div class="loading-overlay">
  <mat-progress-spinner
    diameter="90"
    mode="indeterminate"
  ></mat-progress-spinner>
</div>
